
import { Component, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import store from "@/store";
import OverlayModule from "@/store/modules/core/overlay.module";
import AuthModule from "@/store/modules/core/auth.module";
import { changedPricesService } from "@/services/api/changedPrice.service";
import {
  CatalogueChangedPriceDTO,
  CatalogueChangedPriceMasterDTO,
} from "@/models/entities/changePrice/changedPrice.interface";
const authModule = getModule(AuthModule, store);
const overlayModule = getModule(OverlayModule, store);
const AppBar = () => import("@/components/core/AppBar.vue");
const LoadingOverlay = () => import("@/components/core/LoadingOverlay.vue");
const AppFooter = () => import("@/components/core/AppFooter.vue");
const MessageDialog = () => import("@/components/core/MessageDialog.vue");

@Component({
  components: {
    AppBar,
    AppFooter,
    LoadingOverlay,
    MessageDialog,
  },
})
export default class ChangePrices extends Vue {
  private messageDialogOpen = false;
  private dialogText = "";
  private numberSelected = 0;
  private loadingOverlayOpen = false;
  private dialogEmail = false;
  private isSelectedAll = false;
  private selected = "Seleziona tutte";
  private downlodable = false;
  private dialogNotDownlodable = false;
  private set1 = false;
  private set2 = false;
  private catalogueChangedPriceDTO: CatalogueChangedPriceDTO[];
  private catalogueChangedPriceMasterDTO: CatalogueChangedPriceMasterDTO[];
  private isLoading = false;

  private stores: { id: number; name: string }[] = [
    { id: 1, name: "MAK (002)" },
    { id: 2, name: "AVUS (002)" },
    { id: 3, name: "FONDMETAL (002)" },
    { id: 4, name: "CATALOGO 365 (000)" },
    { id: 5, name: "RUOTINI MASTER (000)" },
    { id: 6, name: "RUOTE IN FERRO (001)" },
    { id: 7, name: "RUOTE IN LEGA MASTER (002)" },
    { id: 8, name: "CATENE DA NEVE (150)" },
  ];

  private catalogueChangedPrice = [
    { text: "Codice Prodotto", value: "productCode" },
    { text: "Marca", value: "brand" },
    { text: "Modello", value: "model" },
    { text: "Anno", value: "fromYear" },
    { text: "Diametro", value: "diameter" },
    { text: "PCD", value: "pcd" },
    { text: "Buchi", value: "hole" },
    { text: "Et", value: "et" },
    { text: "Ean Code", value: "eanCode" },
    { text: "Prezzo Storico", value: "netPrice" },
    { text: "Prezzo Cambiato", value: "netPriceChange" },
    { text: "Conferma", value: "action" },
  ];

  private catalogueChangedPriceMaster = [
    { text: "Codice Prodotto", value: "art_Codice" },
    { text: "Descrizione", value: "art_Descr" },
    { text: "Canale", value: "art_Canale" },
    { text: "ET", value: "art_Et" },
    { text: "Diametro", value: "art_Diametro" },
    { text: "Fori", value: "art_Fori" },
    { text: "PCD", value: "art_Pcd" },
    { text: "Foro Centrale", value: "art_ForoCentrale" },
    { text: "Giacenza", value: "art_GiacenzaAttiva" },
    { text: "Descrizione secondaria", value: "descrizione2" },
    { text: "Descrizione facoltativa", value: "descrizione3" },
    { text: "Prezzo Offerta", value: "prezzoOfferta" },
    { text: "Prezzo Vendita", value: "prezzoVendita" },
    { text: "Prezzo offerta cambiato", value: "prezzoOffertaChange" },
    { text: "Prezzo vendita cambiato", value: "prezzoVenditaChange" },
    { text: "Conferma", value: "action" },
  ];
  private beforeCreate(): void {
    if (authModule.role != "0") {
      this.$router.push("/");
    }
  }

  private changedPrice(choice): void {
    this.dialogEmail = false;
    this.loadingOverlayOpen = true;

    let checkedArray: number[];
    changedPricesService
      .changedPricesService(choice.id, authModule.userEmail)
      .then((res) => {
        //
      })
      .catch((e) => {
        this.loadingOverlayOpen = false;
        console.warn(e);
        this.messageDialogOpen = true;
        this.dialogText = "Non è stato possibile mandare la mail!";
      });
  }

  private control(): void {
    // this.stores.forEach((store) => {
    //   if (store.val == true) {
    //     this.downlodable = true;
    //   }
    // });
    // if (this.downlodable == true) {
    this.dialogEmail = true;
    this.downlodable = false;
    // } else {
    //   this.dialogNotDownlodable = true;
    // }
  }

  // private async downloadZip(code: string, certificate: string): Promise<void> {
  //   // this.loadingOverlayOpen = true;

  //   this.stores.forEach((store) => {
  //     if (store.val == true) {
  //       this.downlodable = true;
  //     }
  //   });
  //   if (this.downlodable == true) {
  //     var result = await changedPricesService.downloadChangedPricesService(
  //       this.stores[0].val,
  //       this.stores[1].val,
  //       this.stores[2].val,
  //       this.stores[3].val,
  //       this.stores[4].val,
  //       this.stores[5].val,
  //       this.stores[6].val,
  //       this.stores[7].val
  //     );
  //     if (result.data.value != "") {
  //       const linkSource = `data:application/pdf;base64,${result.data.value}`;
  //       const downloadLink = document.createElement("a");
  //       const fileName =
  //         result.data.name != null && result.data.name != ""
  //           ? result.data.name
  //           : "file.zip";

  //       downloadLink.href = linkSource;
  //       downloadLink.download = fileName;
  //       downloadLink.click();
  //       this.downlodable = false;
  //     }
  //   } else {
  //     this.dialogNotDownlodable = true;
  //   }
  //   // this.loadingOverlayOpen = false;
  // }
  // private getChangedPrice(): void {
  //   changedPricesService
  //     .getChangedPricesService(
  //       // this.stores[0].val,
  //       // this.stores[1].val,
  //       // this.stores[2].val,
  //       // this.stores[3].val,
  //       // this.stores[4].val,
  //       // this.stores[5].val,
  //       // this.stores[6].val,
  //       // this.stores[7].val
  //     )
  //     .then((res) => {
  //       this.changedPriceResponse = res.data;

  //       this.set = true;
  //     })
  //     .catch((e) => {
  //       this.loadingOverlayOpen = false;
  //       console.warn(e);
  //       this.messageDialogOpen = true;
  //       this.dialogText = "Non è stato possibile mandare la mail!";
  //     });
  // }

  private refreshList(choice): void {
    // Check if type of choice is "object". If not, do nothing (invalid choice from combobox)!
    this.isLoading = true;
    if (typeof choice === "object") {
      if (choice.id) {
        // Get via API
        changedPricesService
          .getChangedPricesService(choice.id)
          .then((res) => {
            if (choice.id == "1") {
              this.catalogueChangedPriceDTO = res.data.mak;
              this.set2 = false;
              this.set1 = true;
            } else if (choice.id == "2") {
              this.catalogueChangedPriceDTO = res.data.avus;
              this.set2 = false;
              this.set1 = true;
            } else if (choice.id == "3") {
              this.catalogueChangedPriceDTO = res.data.fondMetal;
              this.set2 = false;
              this.set1 = true;
            } else if (choice.id == "4") {
              this.catalogueChangedPriceDTO = res.data.ruotiniCatalogo;
              this.set2 = false;
              this.set1 = true;
            } else if (choice.id == "5") {
              this.catalogueChangedPriceMasterDTO = res.data.ruotiniMaster;
              this.set1 = false;
              this.set2 = true;
            } else if (choice.id == "6") {
              this.catalogueChangedPriceMasterDTO = res.data.ironWheelsMaster;
              this.set1 = false;
              this.set2 = true;
            } else if (choice.id == "7") {
              this.catalogueChangedPriceMasterDTO = res.data.alloyWheelsMaster;
              this.set1 = false;
              this.set2 = true;
            } else if (choice.id == "8") {
              this.catalogueChangedPriceMasterDTO = res.data.snowChain;
              this.set1 = false;
              this.set2 = true;
            }
            this.isLoading = false;
          })
          .catch((e) => {
            this.loadingOverlayOpen = false;
            console.warn(e);
            this.messageDialogOpen = true;
            this.dialogText = "Non è stato possibile mandare la mail!";
          });
      } else {
        this.catalogueChangedPriceDTO = [];
      }
    } else {
      this.catalogueChangedPriceDTO = [];
    }
  }
}
